import React, { Component } from "react";
import "./login.css";
import LoginCarImage from "../../assets/images/pexels-jeshootscom-13861.jpg";
import authCred from "../../services/authservice";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";

class Login extends Component {
  state = {
    credDetails: {
      username: "",
      password: "",
      message: "",
    },
  };

  updateUsername(username) {
    this.setState({
      credDetails: {
        username: username,
        password: this.state.credDetails.password,
        message: "",
      },
    });
  }

  updatePassword(password) {
    this.setState({
      credDetails: {
        username: this.state.credDetails.username,
        password: password,
        message: "",
      },
    });
  }

  reset() {
    this.setState({credDetails: {
      username: "",
      password: "",
      message: "",
    }});
  }
  render() {
    return (
      <div className="loginLayout">
        <div className="loginSection m-2">
          <div className="login-text m-2">Please Login to Your Account</div>
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              id="username"
              placeholder="username"
              value={this.state.credDetails.username}
              onChange={(event) => this.updateUsername(event.target.value)}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="password"
              value={this.state.credDetails.password}
              onChange={(event) => this.updatePassword(event.target.value)}
            />
          </div>
          {this.state.credDetails.message.length > 0 ? (
            <Alert color="danger">{this.state.credDetails.message}</Alert>
          ) : (
            <div />
          )}
          <button
            className="btn btn-primary"
            onClick={async (e) => {
              e.preventDefault();
              const token = await authCred(
                this.state.credDetails.username,
                this.state.credDetails.password
              );
              if (token === undefined) {
                this.setState({
                  credDetails: {
                    username: this.state.credDetails.username,
                    password: this.state.credDetails.password,
                    message: "Oops! username/password is incorrect",
                  },
                });
              } else {
                this.props.handleLogin(token, this.state.credDetails.username);
                this.props.history.push("/");
              }
            }}
          >
            Login
          </button>
          <button
            type="reset"
            className="btn btn-secondary m-1"
            onClick={() => this.reset()}
          >
            Reset
          </button>
        </div>
        <div className="imageSection">
          <img className="img-fluid" alt="" src={LoginCarImage} />
        </div>
      </div>
    );
  }
}

export default Login;
